<template>
  <div class="Warning">
    <div class="banner">
      <div class="banner_title">
        <h1>钱湖柏庭</h1>
        <p>ABOUT BOTING LIVING</p>
      </div>
    </div>
    <div class="service_bd">
      <LeftNav
        title="钱湖柏庭"
        :list="list"
        @event1="change($event)"
        bigTitle="ABOUT BOTING LIVING"
        :key="changing"
        :newData="newData"
      ></LeftNav>
      <div class="bd_right">
        <router-view></router-view>
        <!-- <homeItem1
          title="钱湖柏庭"
          :list="list"
          :newData="newData"
          v-if="newData == 0"
        ></homeItem1>
         <homeItem2
          title="钱湖柏庭"
          :list="list"
          :newData="newData"
          v-if="newData == 1"
        ></homeItem2>
         <homeItem3
          title="钱湖柏庭"
          :list="list"
          :newData="newData"
          v-if="newData == 2"
        ></homeItem3>
         <homeItem4
          title="钱湖柏庭"
          :list="list"
          :newData="newData"
          v-if="newData == 3"
        ></homeItem4> -->
      </div>
    </div>
  </div>
</template>
  <script>
import LeftNav from "../components/leftNav.vue";

export default {
  name: "Warning",
  data() {
    return {
      changing: 0,
      list: [
        {
          title: "项目简介",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "项目简介",
          option: "1",
        },
        {
          title: "柏庭相册",
          small_title: "BOTING PHOTO ALBUM",
          hasTitle: "柏庭相册",
          option: "0.75",
        },
        {
          title: "项目位置",
          small_title: "PROJECT LOCATION",
          hasTitle: "项目位置",
          option: "0.5",
        },
        {
          title: "新闻中心",
          small_title: "NEW CENTER",
          hasTitle: "新闻中心",
          option: "0.25",
          children: [
           
          ],
        },
      ],
      newData: 0,
    };
  },
  methods: {
    change(data) {
      this.newData = data;
      this.changing += 1;
    
    },
  },
  mounted: function () {
    //获取年
    var myDate = new Date();
   this.$store.state.year =myDate.getFullYear()
    let YearList = myDate.getFullYear() - 2018;
    let year = [];

    for (let i = 0; i <= YearList; i++) {
      let arr = myDate.getFullYear() - i;
      let obj=new Object;
      obj.title=arr;
      obj.id=i;
      obj.option='0.1';
      obj.year=arr
      year.push(obj);
    }

    this.list[3].children=year;
    this.changing+=1;
    // this.$router.push({ path: "/Home/homeItem1" });
  },
  components: {
    LeftNav,
  },
  watch: {
    newData: {
      handler: function () {
       
       
        //do something
        if (
          this.newData == 0 &&
          window.location.href.indexOf("/Home/homeItem1") == -1
        ) {
          this.$router.push({ path: "/Home/homeItem1" });
        } else if (
          this.newData == 1 &&
          window.location.href.indexOf("/Home/homeItem2") == -1
        ) {
          this.$router.push({ path: "/Home/homeItem2" });
        } else if (
          this.newData == 2 &&
          window.location.href.indexOf("/Home/homeItem3") == -1
        ) {
          this.$router.push({ path: "/Home/homeItem3" });
        } else if (
          this.newData == 3 &&
          window.location.href.indexOf("/Home/homeItem4") == -1
        ) {
          if (this.$route.query.majorName) {
            // this.$router.push({ path: "/Home/homelist" });
          } else {
            this.$router.push({ path: "/Home/homeItem4" });
          }
        }
      },
      deep: true,
    },
    $route: {
      handler(newRouter) {
       
        if (newRouter.path == "/Home/homeItem1") {
          this.newData = 0;
        } else if (newRouter.path == "/Home/homeItem2") {
          this.newData = 1;
        } else if (newRouter.path == "/Home/homeItem3") {
          this.newData = 2;
        } else if (newRouter.path == "/Home/homeItem4") {
          this.newData = 3;
        } else if (newRouter.path == "/Home/homelist") {
          this.newData = 3;
        } else if (newRouter.path == "/Home/photoList") {
          this.newData = 1;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style scoped="scoped">
.banner {
  width: 100%;
  height: 8.75rem;
  background-image: url("../assets/image/home/home_banner.png");
  background-size: 100% 100%;
  position: relative;
}
.banner_title {
  position: absolute;
  left: 2.5rem;
  bottom: 2.125rem;
  width: 5.6625rem;
  height: 2.6375rem;
  background-color: rgba(64, 104, 76, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 0.4875rem;
}
.banner_title h1 {
  font-size: 0.65rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.banner_title p {
  font-size: 0.4rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
}
.service_bd {
  padding: 0.75rem 2.5rem 0;
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.6875rem;
}
.bd_right {
  width: 12.6rem;
}
</style>